import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasCalidadTrabajo from "../../hooks/usePreguntasCalidadTrabajo";

const PreguntasCalidadTrabajo = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasCalidadTrabajo();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Calidad de trabajo (2/6)"
			opciones={[
				{ key: "realizaTrabajosPrecisionSinNecesidadDeRetrabajo", label: "Realiza los trabajos con precisión y sin necesidad de retrabajo" },
				{ key: "cumpleEstandaresCalidadEstablecidosPorElTaller", label: "Cumple con los estándares de calidad establecidos por el taller" },
				{ key: "sigueProcedimientosYNormasSeguridad", label: "Sigue los procedimientos y normas de seguridad al trabajar" }			]}
		/>
	);
};

export default PreguntasCalidadTrabajo;
